import { useMutation, useQueryClient } from 'react-query';
import {
  changeSubscription,
  type ChangeSubscriptionBody,
  type ChangeSubscriptionResponse
} from '../../services/subscriptionService';

export function useChangeSubscription() {
  const queryClient = useQueryClient();
  return useMutation<ChangeSubscriptionResponse, Error, ChangeSubscriptionBody>(
    (body) => changeSubscription(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['mySubscription']);
      }
    }
  );
}
